import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setPastProducts } from "../redux/slice/preview/previewSlice";
// Update the import path to the correct location

const UrlParamSync = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dispatch = useDispatch();

  useEffect(() => {
    // Run only for the specific route
    if (location.pathname.includes("/publicpreview/pastproducts")) {
      const pastProductsParam = searchParams.get("pastProducts");
      dispatch(setPastProducts(pastProductsParam === "true"));
    } else {
      dispatch(setPastProducts(false)); // reset when leaving route
    }
  }, [location.pathname, searchParams, dispatch]);

  return null; // no UI
};

export default UrlParamSync;
